module.exports = __webpack_public_path__ + "d7e2e0d97fdb515781424efdc0bc8cd4.svg";